module.exports = __webpack_public_path__ + "static/img/3.93c66e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/3.png
// module id = pN/w
// module chunks = 0